import { httpApi } from '@app/api/http.api';

export interface MailerSettingData {
  host: string;
  port: number;
  username: string;
  password: string;
}

export const getMailerConfig = (): Promise<MailerSettingData> =>
  httpApi.get<MailerSettingData>('/app-settings/mailer').then(({ data }) => data);

export const updateMailerConfig = (data: MailerSettingData): Promise<undefined> =>
  httpApi.put<undefined>(`/app-settings/mailer`, { ...data }).then(({ data }) => data);
